import { render } from "./AppFrame.vue?vue&type=template&id=eaf935ac&scoped=true"
import script from "./AppFrame.vue?vue&type=script&lang=js"
export * from "./AppFrame.vue?vue&type=script&lang=js"

import "./AppFrame.vue?vue&type=style&index=0&id=eaf935ac&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf935ac"]])

export default __exports__